// removed by extract-text-webpack-plugin
module.exports = {"privacyTable":"_2yss9eFQt9rEj4bQmAbTDv","header":"_1G-X-Vb-ZUYTD06o2GW60Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/PrivacyPolicy/PrivacyPolicy.scss
// module id = 1276
// module chunks = 1